import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import { encodeObjToStr } from "./utils";
import Boss from "../boss/boss";
var boss = new Boss({
  BossId: '4710',
  Pwd: '8476392'
});
var defaultBusi = {
  base: 'video_vip_fe',
  project: 'page',
  module: 'default'
};
/**
 * 棱镜Monitor上报
 */

var Monitor = /*#__PURE__*/function () {
  /**
     * 创建个Monitor上报器
     * @param options 上报路径，包括项目和模块等信息
     */
  function Monitor(options) {
    _classCallCheck(this, Monitor);

    this.busi = Object.assign({}, defaultBusi, options);
  }
  /**
     * 棱镜monitor上报
     * @param metrics 指标对象
     * @param tags 标签对象
     */


  _createClass(Monitor, [{
    key: "report",
    value: function report(metrics) {
      var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var busi = "".concat(this.busi.base, ".").concat(this.busi.project, ".").concat(this.busi.module);
      var metricsStr = encodeObjToStr(this.normalizeMetrics(metrics));
      var tagsStr = encodeObjToStr(tags);
      boss.report({
        busi: busi,
        metrics: metricsStr,
        tags: tagsStr
      });
    }
    /**
       * 上报，值为1
       * @param metric 指标
       */

  }, {
    key: "one",
    value: function one(metric) {
      this.report(_defineProperty({}, metric, 1));
    }
    /**
       * 上报，值为value
       * @param metric 指标
       * @param value 值
       */

  }, {
    key: "count",
    value: function count(metric, value) {
      this.report(_defineProperty({}, metric, value));
    }
  }, {
    key: "normalizeMetrics",
    value: function normalizeMetrics(metrics) {
      Object.keys(metrics).forEach(function (key) {
        metrics[key] = Math.round(metrics[key]);
      });
      return metrics;
    }
  }]);

  return Monitor;
}();

export { Monitor as default };